import React from "react";
import styles from "./QuantityCounter.module.scss";

interface QuantityCounterProps {
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
  maxQuantity: number;
}

export const QuantityCounter: React.FC<QuantityCounterProps> = ({
  quantity,
  onIncrease,
  onDecrease,
  maxQuantity,
}) => {
  return (
    <div className={styles.quantity}>
      <button
        className={styles.quantity_button}
        onClick={onDecrease}
        disabled={quantity <= 1}
      >
        <span>-</span>
      </button>
      <span className={styles.quantity_value}>
        {quantity}
      </span>
      <button
        className={styles.quantity_button}
        onClick={onIncrease}
        disabled={quantity >= maxQuantity}
      >
        <span>+</span>
      </button>
    </div>
  );
};

